import WYSIWYG from '@components/ui/WYSIWYG'
import { Content } from '@prismicio/client'
import { SliceComponentProps } from '@prismicio/react'
import { RichTextBlock } from 'prismic-reactjs'

/**
 * Props for `AcknowledgementsV2`.
 */
export type AcknowledgementsV2Props =
  SliceComponentProps<Content.AcknowledgementsV2Slice>

/**
 * Component for "AcknowledgementsV2" Slices.
 */
const AcknowledgementsV2 = ({
  slice,
}: AcknowledgementsV2Props): JSX.Element => {
  const { items } = slice
  const { primary } = slice

  const firstLinkText = primary?.firstLinkText
  const firstTitle = primary?.firstTitle

  const secondLinkText = primary?.secondLinkText
  const secondTitle = primary?.secondTitle

  return (
    <div className="wrapper bg-ui-light-grey pt-10 pb-16 lg:pb-30">
      <div className="flex gap-[29px] lg:gap-[37px]">
        <div className="label-bold flex flex-col gap-3 ">
          {firstTitle && <WYSIWYG content={firstTitle as RichTextBlock[]} />}
          {secondTitle && <WYSIWYG content={secondTitle as RichTextBlock[]} />}
        </div>
        <div className="label flex flex-col gap-6">
          <div className="label flex flex-col gap-3">
            <WYSIWYG content={firstLinkText as RichTextBlock[]} />
            <WYSIWYG content={secondLinkText as RichTextBlock[]} />
          </div>
          <div className="label flex flex-col gap-3">
            {items && (
              <>
                {items.map((item: any, index: number) => {
                  return (
                    <div key={index}>
                      <WYSIWYG
                        content={item?.otherLinkText as RichTextBlock[]}
                      />
                    </div>
                  )
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AcknowledgementsV2
